import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { getBlob } from '../../services/api';
import { useTheme } from '../../ThemeContext';
import { normalizeResolvedTheme } from '../../constants/theme';
import './background.css';

function Background() {
    const [backgroundImageUrl, setBackgroundImageUrl] = useState(undefined);
    const { resolvedTheme, isThemeReady } = useTheme();

    useEffect(() => {
        if (!isThemeReady) {
            setBackgroundImageUrl(undefined);
            return;
        }

        let objectUrl;
        let isCurrentRequest = true;

        async function getBackgroundImage() {
            const apiTheme = normalizeResolvedTheme(resolvedTheme);
            await getBlob(`/config/background-image?theme=${encodeURIComponent(apiTheme)}`, true, () => {},
                (response) => {
                    if (!isCurrentRequest) {
                        return;
                    }

                    if (!(response.data instanceof Blob) || response.data.size === 0) {
                        setBackgroundImageUrl(undefined);
                        return;
                    }

                    objectUrl = URL.createObjectURL(response.data);
                    setBackgroundImageUrl(objectUrl);
                },
                () => {
                    if (!isCurrentRequest) {
                        return;
                    }

                    setBackgroundImageUrl(undefined);
                },
                () => {},
                'logout',
                'none',
                'none'
            );
        }

        getBackgroundImage();

        return () => {
            isCurrentRequest = false;

            if (objectUrl)
                URL.revokeObjectURL(objectUrl);
        };
    }, [resolvedTheme, isThemeReady]);

    const backgroundStyle = backgroundImageUrl
        ? { '--background-image': `url(${backgroundImageUrl})` }
        : { '--background-image': 'none' };

    return (
        <>
            <div className="background" style={backgroundStyle}></div>
            <Outlet />
        </>
    );
}

export default Background;